import * as Sentry from "@sentry/react";

const sentryEnvironment = () => {
  const env = process.env.NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT || "developer";
  switch (env) {
    case "prod":
      return "production";
    case "dev":
      return "development";
    default:
      return env;
  }
};

Sentry.init({
  dsn: "https://7f22939566d18c7d52d22c8808a7f456@o4506152281374720.ingest.us.sentry.io/4506157510295552",
  enableLogs: true,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined,
  integrations: [Sentry.consoleLoggingIntegration()],
  environment: sentryEnvironment(),
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED === "1",

  // Drop errors originating from browser extensions (MetaMask, Phantom, etc.)
  // — their injected scripts throw in our pages but aren't ours to fix.
  // denyUrls matches against stack frame source URLs (not the page URL).
  // Docs: https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#denyurls
  //
  // If third-party noise grows beyond browser extensions, consider graduating to
  // Sentry.thirdPartyErrorFilterIntegration (SDK 8.10.0+), which uses a build-time
  // application key to drop any error with no first-party frames. Requires the
  // Sentry bundler plugin, so it's heavier to set up than denyUrls.
  // Docs: https://docs.sentry.io/platforms/javascript/configuration/filtering/#filtering-error-events
  denyUrls: [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-extension:\/\//,
    /^safari-web-extension:\/\//,
  ],

  // We don't call `window.webkit.messageHandlers` anywhere; any error mentioning
  // it comes from third-party JS inside an iOS WKWebView context (in-app browsers,
  // SDKs probing for native bridges).
  ignoreErrors: [/window\.webkit\.messageHandlers/],

  // Strip query params — they can contain presigned tokens, API keys, etc.
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch") {
      return breadcrumb;
    }
    const data = breadcrumb.data;
    if (!data || typeof data.url !== "string") {
      return breadcrumb;
    }
    try {
      const url = new URL(data.url);
      data.url = `${url.origin}${url.pathname}`;
    } catch {
      // Invalid URL, keep as-is
    }
    return breadcrumb;
  },
});
